import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import * as urlService from "../../view/urlService";
import { Folder as FolderIcon, FolderOpen, ChevronRight, ChevronDown } from "lucide-react";
import { Spinner } from "../../view/Spinner";

export function Folder(props) {

    const history = useHistory();
    useLocation(); // To track URL changes and trigger re-render
    const [open, setOpen] = useState(false);

    const filterKey = props.filterKey;
    const children = props.data;
    const label = props.label;
    const loading = props.loading;
    const hasChildren = children && children.length > 0;
    const showLoader = open && loading && !hasChildren;

    const queryParams = urlService.getParams();
    const activeValue = queryParams[`f_${filterKey}`];

    // Check if one of the children is currently active
    const hasActiveChild = children && children.some(child => String(child.value) === activeValue);

    const onClick = (value, label) => {
        if (value) {
            history.push({
                pathname: history.pathname,
                search: urlService.updateMsbTableParams(filterKey, value, label)
            })
        }
    }

    const onFolderClick = () => {
        setOpen(!open);
        onClick(); // Keeps the original empty call behavior for the parent if needed
    }

    return (
        <div className="mb-2">
            <button
                className={`addrules-tab-btn-v2 oct_folder-btn ${hasActiveChild ? 'active' : ''} w-100 d-flex align-items-center`}
                onClick={onFolderClick}
            >
                {open ? <ChevronDown size={16} className="me-2" /> : <ChevronRight size={16} className="me-2" />}
                {open ? <FolderOpen size={18} className="me-2 folder-icon" /> : <FolderIcon size={18} className="me-2 folder-icon" />}
                <span className="flex-grow-1">{label}</span>
            </button>

            {showLoader && (
                <div className="oct_folder-loading">
                    <Spinner />
                    <span>Loading options...</span>
                </div>
            )}

            {open && hasChildren && (
                <div className="d-flex flex-column mt-1 oct_folder-children">
                    {children.map((child, index) => {
                        const isChildActive = activeValue === String(child.value);
                        return (
                            <button
                                key={index}
                                className={`addrules-tab-btn-v2 oct_folder-child-btn ${isChildActive ? 'active' : ''} w-100 d-flex align-items-center`}
                                onClick={() => onClick(child.value, child.label)}
                            >
                                <FolderIcon size={15} className="me-2 folder-icon" />
                                <span className="flex-grow-1">{child.label}</span>
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    )

}

export default Folder;
